export default {
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
}
